<template>
  <div style="height: 100%;width: 100%">
    <h2>{{ $t('makeSchedule.processProductionSchedulingCalendar.productionScheduleCalendar') }}</h2>
    <el-container style="height: 95%;width: 100%">
      <el-aside width="68%" class="border" style="height: 100%">
        <el-calendar class="el-calendar" v-model="value" ref="calendar">
          <template #header="{ date }">
            <span></span>
            <h2 style="font-size: 25px">{{ date }}</h2>
            <el-button-group>
              <el-button style="font-size: 20px" @click="selectDate('prev-month')"><el-icon><ElIconArrowLeft /></el-icon></el-button>
              <el-button style="font-size: 18px" @click="selectDate('today')">今</el-button>
              <el-button style="font-size: 20px" @click="selectDate('next-month')"><el-icon><ElIconArrowRight /></el-icon></el-button>
            </el-button-group>
          </template>
          <template #date-cell="{ data }">
            <div :class="data.isSelected ?'dateDiv_1':'dateDiv'" :dataInfo="item=showWorkDate(data.day)" @click="confirmValue(data.day)">
              <text :class="data.isSelected ? 'is-selected' : ''" v-if="data.type === 'current-month'" class="dayDiv">
                {{ data.day.split('-').slice(2).join() >= 10 ? data.day.split('-').slice(2).join() : data.day.split('-').slice(2).join().replace(0, '') }}
              </text>
              <div class="div-text">
                <text class="workDiv" v-if="item.work_type==='work' && data.type === 'current-month'">{{ "班" }}</text>
                <text class="holidayDiv" v-if="item.work_type==='holiday' && data.type === 'current-month'">{{"节"}}</text>
                <text class="restDiv" v-if="item.work_type==='weekend' && data.type === 'current-month'">{{"休"}}</text>
              </div>

              <div class="row" v-if="data.type === 'current-month'">
                <div :class="item.day_shift_line_pretreatment == true?'day_shift_type_true color1':'day_shift_type_false'">{{ item.day_shift_line_pretreatment ? '前' : '' }}</div>
                <div :class="item.day_shift_line_powder == true?'day_shift_type_true color2':'day_shift_type_false'">{{ item.day_shift_line_powder ? '粉' : '' }}</div>
                <div :class="item.day_shift_line_liquid == true?'day_shift_type_true color3':'day_shift_type_false'">{{ item.day_shift_line_liquid ? '液' : '' }}</div>
              </div>

              <div class="row" v-if="data.type === 'current-month'">
                <div :class="item.night_shift_line_pretreatment == true?'night_shift_type_true color1':'night_shift_type_false'">{{ item.night_shift_line_pretreatment ? '前' : '' }}</div>
                <div :class="item.night_shift_line_powder == true?'night_shift_type_true color2':'night_shift_type_false'">{{ item.night_shift_line_powder ? '粉' : '' }}</div>
                <div :class="item.night_shift_line_liquid == true?'night_shift_type_true color3':'night_shift_type_false'">{{ item.night_shift_line_liquid ? '液' : '' }}</div>
              </div>
            </div>
          </template>
        </el-calendar>
      </el-aside>
      <div style="width: 1%"></div>
      <el-container>
        <h2 style="margin-top: -33px">{{ $t('makeSchedule.processProductionSchedulingCalendar.todayDetails') }}</h2>
        <el-header height="46%" style="height: 46%;overflow-y: auto" class="border">
          <div style="font-size: 25px;margin-top: 4%;text-align: center;color: rgb(4, 134, 254)">{{ selectedYear }}
            <span style="color: black;font-size: 20px">年&nbsp;</span>{{ selectedMonth }}
            <span style="color: black;font-size: 20px">月&nbsp;</span>{{ selectedDay }}
            <span style="color: black;font-size: 20px">日</span>
          </div>
          <div style="font-size: 20px;text-align: center;">{{ selectedWeek }}</div>
          <div style="text-align: center;margin-top: 3%;margin-left:-24px;font-size: 20px">
            <span>类型：</span>
            <el-button-group>
              <el-button :type="dateButtonTypeClass" class="date_button" v-model="dateButtonModel"
                         @click="dateButtonClass(dateButtonModelClass)" style="width: 90px;">班
              </el-button>
              <el-button :type="dateButtonTypeStop" class="date_button" v-model="dateButtonModel"
                         @click="dateButtonStop(dateButtonModelStop)" style="width: 90px;">休
              </el-button>
              <el-button :type="dateButtonTypeJoint" class="date_button" v-model="dateButtonModel"
                         @click="dateButtonJoint(dateButtonModelJoint)" style="width: 90px;">节
              </el-button>
            </el-button-group>
          </div>
          <div style="margin-top: 3%;" class="row">
            <span>{{ $t('makeSchedule.processProductionSchedulingCalendar.dayShift') }}：</span>
            <div @click="dayShiftButton3"
                 :class="dayShift.dayShiftButtonBool3? 'day_shift_button_true color1' : 'day_shift_button_false'">前
            </div>
            <div @click="dayShiftButton1"
                 :class="dayShift.dayShiftButtonBool1? 'day_shift_button_true color2' : 'day_shift_button_false'">粉
            </div>
            <div @click="dayShiftButton2"
                 :class="dayShift.dayShiftButtonBool2? 'day_shift_button_true color3' : 'day_shift_button_false'">液
            </div>
          </div>
          <div style="margin-top: 3%;" class="row">
            <span>{{ $t('makeSchedule.processProductionSchedulingCalendar.nightShift') }}：</span>
            <div @click="nightShiftButton3"
                 :class="nightShift.nightShiftButtonBool3? 'night_shift_button_true color1' : 'night_shift_button_false'">前
            </div>
            <div @click="nightShiftButton1"
                 :class="nightShift.nightShiftButtonBool1? 'night_shift_button_true color2' : 'night_shift_button_false'">粉
            </div>
            <div @click="nightShiftButton2"
                 :class="nightShift.nightShiftButtonBool2? 'night_shift_button_true color3' : 'night_shift_button_false'">液
            </div>
          </div>
          <div style="text-align: center;margin-top: 5%;">
            <el-button style="width: 100px;height: 35px" type="primary" :loading="loading" @click="buttonClick">保存</el-button>
          </div>
        </el-header>
        <h2 style="display:flex;margin: 10px 0;">{{ $t('makeSchedule.processProductionSchedulingCalendar.batchManagement') }}</h2>
        <el-main height="53%" class="border">
          <div style="text-align: center;display: flex">
            <span style="font-size: 20px;">日期：</span>
            <el-date-picker style="width: 255px" v-model="dateInterval" value-format="YYYY-MM-DD" type="daterange"
                            range-separator="~" start-placeholder="开始时间" end-placeholder="结束时间"/>
          </div>
          <div style="margin-top: 3%;text-align: center;margin-left: -20px">
            <span style="font-size: 20px">{{ $t('makeSchedule.processProductionSchedulingCalendar.onlyModifyTheWeek') }}：</span>
            <el-checkbox style="width: 4%"  v-model="checkList[1].checkBox1" :label="$t('makeSchedule.processProductionSchedulingCalendar.one')" />
            <el-checkbox style="width: 4%"  v-model="checkList[2].checkBox2" :label="$t('makeSchedule.processProductionSchedulingCalendar.two')" />
            <el-checkbox style="width: 4%"  v-model="checkList[3].checkBox3" :label="$t('makeSchedule.processProductionSchedulingCalendar.three')" />
            <el-checkbox style="width: 4%"  v-model="checkList[4].checkBox4" :label="$t('makeSchedule.processProductionSchedulingCalendar.four')" />
            <el-checkbox style="width: 4%"  v-model="checkList[5].checkBox5" :label="$t('makeSchedule.processProductionSchedulingCalendar.five')" />
            <el-checkbox style="width: 4%"  v-model="checkList[6].checkBox6" :label="$t('makeSchedule.processProductionSchedulingCalendar.six')" />
            <el-checkbox style="width: 4%"  v-model="checkList[0].checkBox0" label="日" />
          </div>
          <div style="margin-top: 3%" class="row">
            <span style="font-size: 20px">{{ $t('makeSchedule.processProductionSchedulingCalendar.dayShift') }}：</span>
            <div @click="dayShiftBatchButton3"
                 :class="dayShiftBatch.dayShiftButtonBool3? 'day_shift_button_true color1' : 'day_shift_button_false'">前
            </div>
            <div @click="dayShiftBatchButton1"
                 :class="dayShiftBatch.dayShiftButtonBool1? 'day_shift_button_true color2' : 'day_shift_button_false'">粉
            </div>
            <div @click="dayShiftBatchButton2"
                 :class="dayShiftBatch.dayShiftButtonBool2? 'day_shift_button_true color3' : 'day_shift_button_false'">液
            </div>
          </div>
          <div style="margin-top: 3%" class="row">
            <span style="font-size: 20px">{{ $t('makeSchedule.processProductionSchedulingCalendar.nightShift') }}：</span>
            <div @click="nightShiftBatchButton3"
                 :class="nightShiftBatch.nightShiftButtonBool3? 'night_shift_button_true color1' : 'night_shift_button_false'">
              前
            </div>
            <div @click="nightShiftBatchButton1"
                 :class="nightShiftBatch.nightShiftButtonBool1? 'night_shift_button_true color2' : 'night_shift_button_false'">
              粉
            </div>
            <div @click="nightShiftBatchButton2"
                 :class="nightShiftBatch.nightShiftButtonBool2? 'night_shift_button_true color3' : 'night_shift_button_false'">
              液
            </div>
          </div>

          <div style="text-align: center;margin-top: 5%">
            <el-button style="width: 100px;height: 35px" type="primary" :loading="batchLoading" @click="batchButtonClick">保存
            </el-button>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import moment from "moment/moment";

export default {
  name: "PaintingProductionSchedulingCalendar",
  data() {
    return {
      value: new Date(),
      dateMap: [],
      selectedYear: '', //年
      selectedWeek: '', //周
      selectedMonth: '',//月
      selectedDay: '',//天
      radio: '',
      confirmBool:false,
      //以下处理类型
      dateButtonModel: '',
      dateButtonModelClass: 'work',
      dateButtonModelStop: 'weekend',
      dateButtonModelJoint: 'holiday',
      dateButtonTypeClass: '',
      dateButtonTypeStop: '',
      dateButtonTypeJoint: '',
      //只修改周
      checkList: [
        {checkBox0: false},
        {checkBox1: true},
        {checkBox2: true},
        {checkBox3: true},
        {checkBox4: true},
        {checkBox5: true},
        {checkBox6: true}
      ],
      //以下处理白班
      dayShift: {
        dayShiftButtonBool1: false,
        dayShiftButtonBool2: false,
        dayShiftButtonBool3: false
      },
      dayShiftBatch: {
        dayShiftButtonBool1: false,
        dayShiftButtonBool2: false,
        dayShiftButtonBool3: false
      },
      //以下处理夜班
      nightShift: {
        nightShiftButtonBool1: false,
        nightShiftButtonBool2: false,
        nightShiftButtonBool3: false
      },
      nightShiftBatch: {
        nightShiftButtonBool1: false,
        nightShiftButtonBool2: false,
        nightShiftButtonBool3: false
      },
      loading: false,
      batchLoading: false,
      dateInterval: '',
    }
  }, methods: {
    //清除批量值
    clearData() {
      this.dateInterval = '';
      this.nightShiftBatch.nightShiftButtonBool1 = false;
      this.nightShiftBatch.nightShiftButtonBool2 = false;
      this.nightShiftBatch.nightShiftButtonBool3 = false;
      this.dayShiftBatch.dayShiftButtonBool1 = false;
      this.dayShiftBatch.dayShiftButtonBool2 = false;
      this.dayShiftBatch.dayShiftButtonBool3 = false;
    },
    //total查询 组件自带
    selectDate(value) {
      this.$refs.calendar.selectDate(value)
      this.getWorkDateList(this.value)
      let day = moment(this.value).format("YYYY-MM-DD")
      this.timer1 = setTimeout(() => {
        this.confirmValue(day)
      }, 200)
    },
    getWorkDateList(date) {
      let params = {work_date: date}
      this.$axios.post('mfg/paintingCalendar/selectMonthData', params).then(response => {
        let res = response.data
        if (res.code !== 0) {
          this.$message.error("获取数据失败");
        }
        this.dateMap = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    //显示工作日 日期
    showWorkDate(day) {
      if (this.dateMap[day]) {
        return this.dateMap[day]
      }
      return ""
    },
    //填充当日详情数据
    confirmValue(value) {
      this.confirmBool = true;
      const weeks = ['一', '二', '三', '四', '五', '六', '日']
      let date = new Date(value);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      this.selectedYear = year
      this.selectedMonth = month;
      this.selectedDay = day;
      this.selectedWeek = "周" + weeks[date.getDay() - 1];
      if (date.getDay() == 0) {
        this.selectedWeek = "周" + weeks[6];
      }

      if (this.dateMap[value] !== undefined) {
        let item = this.dateMap[value];
        if (item.work_type === 'work') {
          this.dateButtonTypeClass = 'primary'
          this.dateButtonTypeStop = ''
          this.dateButtonTypeJoint = ''
          this.dateButtonModel = 'work'
        } else if (item.work_type === 'weekend') {
          this.dateButtonTypeStop = 'primary'
          this.dateButtonTypeClass = ''
          this.dateButtonTypeJoint = ''
          this.dateButtonModel = 'weekend';
        } else if (item.work_type === 'holiday') {
          this.dateButtonTypeStop = ''
          this.dateButtonTypeClass = ''
          this.dateButtonTypeJoint = 'primary'
          this.dateButtonModel = 'holiday';
        }

        this.dayShift.dayShiftButtonBool1 = item.day_shift_line_powder;
        this.dayShift.dayShiftButtonBool2 = item.day_shift_line_liquid;
        this.dayShift.dayShiftButtonBool3 = item.day_shift_line_pretreatment;
        this.nightShift.nightShiftButtonBool1 = item.night_shift_line_powder;
        this.nightShift.nightShiftButtonBool2 = item.night_shift_line_liquid;
        this.nightShift.nightShiftButtonBool3 = item.night_shift_line_pretreatment;
      }
    },
    //班休节 按钮
    dateButtonClass(dateButtonModel) {
      let day = moment(this.value).format("YYYY-MM-DD")
      this.confirmValue(day)
      this.dateButtonModel = dateButtonModel;
      this.dateButtonTypeClass = 'primary'
      this.dateButtonTypeStop = ''
      this.dateButtonTypeJoint = ''
    },
    dateButtonStop(dateButtonModel) {
      this.dayShift.dayShiftButtonBool1 = false;
      this.dayShift.dayShiftButtonBool2 = false;
      this.dayShift.dayShiftButtonBool3 = false;
      this.nightShift.nightShiftButtonBool1 = false;
      this.nightShift.nightShiftButtonBool2 = false;
      this.nightShift.nightShiftButtonBool3 = false;

      this.dateButtonModel = dateButtonModel;
      this.dateButtonTypeClass = ''
      this.dateButtonTypeStop = 'primary'
      this.dateButtonTypeJoint = ''
    },
    dateButtonJoint(dateButtonModel) {
      this.dayShift.dayShiftButtonBool1 = false;
      this.dayShift.dayShiftButtonBool2 = false;
      this.dayShift.dayShiftButtonBool3 = false;
      this.nightShift.nightShiftButtonBool1 = false;
      this.nightShift.nightShiftButtonBool2 = false;
      this.nightShift.nightShiftButtonBool3 = false;

      this.dateButtonModel = dateButtonModel;
      this.dateButtonTypeClass = ''
      this.dateButtonTypeStop = ''
      this.dateButtonTypeJoint = 'primary'
    },
    //白班 按钮
    dayShiftButton1() {
      if (this.dayShift.dayShiftButtonBool1) {
        this.dayShift.dayShiftButtonBool1 = false;
      } else {
        this.dayShift.dayShiftButtonBool1 = true;
      }
    },
    dayShiftButton2() {
      if (this.dayShift.dayShiftButtonBool2) {
        this.dayShift.dayShiftButtonBool2 = false;
      } else {
        this.dayShift.dayShiftButtonBool2 = true;
      }
    },
    dayShiftButton3() {
      if (this.dayShift.dayShiftButtonBool3) {
        this.dayShift.dayShiftButtonBool3 = false;
      } else {
        this.dayShift.dayShiftButtonBool3 = true;
      }
    },
    // 夜班 按钮
    nightShiftButton1() {
      if (this.nightShift.nightShiftButtonBool1) {
        this.nightShift.nightShiftButtonBool1 = false;
      } else {
        this.nightShift.nightShiftButtonBool1 = true;
      }
    },
    nightShiftButton2() {
      if (this.nightShift.nightShiftButtonBool2) {
        this.nightShift.nightShiftButtonBool2 = false;
      } else {
        this.nightShift.nightShiftButtonBool2 = true;
      }
    },
    nightShiftButton3() {
      if (this.nightShift.nightShiftButtonBool3) {
        this.nightShift.nightShiftButtonBool3 = false;
      } else {
        this.nightShift.nightShiftButtonBool3 = true;
      }
    },
    dayShiftBatchButton1() {
      if (this.dayShiftBatch.dayShiftButtonBool1) {
        this.dayShiftBatch.dayShiftButtonBool1 = false;
      } else {
        this.dayShiftBatch.dayShiftButtonBool1 = true;
      }
    },
    dayShiftBatchButton2() {
      if (this.dayShiftBatch.dayShiftButtonBool2) {
        this.dayShiftBatch.dayShiftButtonBool2 = false;
      } else {
        this.dayShiftBatch.dayShiftButtonBool2 = true;
      }
    },
    dayShiftBatchButton3() {
      if (this.dayShiftBatch.dayShiftButtonBool3) {
        this.dayShiftBatch.dayShiftButtonBool3 = false;
      } else {
        this.dayShiftBatch.dayShiftButtonBool3 = true;
      }
    },
    // 夜班 按钮
    nightShiftBatchButton1() {
      if (this.nightShiftBatch.nightShiftButtonBool1) {
        this.nightShiftBatch.nightShiftButtonBool1 = false;
      } else {
        this.nightShiftBatch.nightShiftButtonBool1 = true;
      }
    },
    nightShiftBatchButton2() {
      if (this.nightShiftBatch.nightShiftButtonBool2) {
        this.nightShiftBatch.nightShiftButtonBool2 = false;
      } else {
        this.nightShiftBatch.nightShiftButtonBool2 = true;
      }
    },
    nightShiftBatchButton3() {
      if (this.nightShiftBatch.nightShiftButtonBool3) {
        this.nightShiftBatch.nightShiftButtonBool3 = false;
      } else {
        this.nightShiftBatch.nightShiftButtonBool3 = true;
      }
    },
    buttonClick() {
      if (!this.dateButtonModel) {
        return this.$message.error("类型不能为空！");
      }

      this.loading = true;
      let params = {dayShiftData: this.dayShift, nightShiftData: this.nightShift, type: this.dateButtonModel, date:this.value}
      this.$axios.post('mfg/paintingCalendar/updateDayDetail', params).then(response => {
        this.loading = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.$message.success("修改成功");
        this.getWorkDateList(this.value);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })

    },
    batchButtonClick() {
      if (!this.dateInterval) {
        return this.$message.error("日期不能为空！");
      }

      this.batchLoading = true;
      let params = {dayShiftBatchData: this.dayShiftBatch, nightShiftBatchData: this.nightShiftBatch, dateList:this.dateInterval, checkList:this.checkList}
      this.$axios.post('mfg/paintingCalendar/batchUpdateWorkDate', params).then(response => {
        this.batchLoading = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }
        this.clearData()
        this.$message.success("批量修改成功");
        this.getWorkDateList(this.value);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    }
  }, created() {
    this.getWorkDateList(this.value)
    this.timer1 = setTimeout(() => {
      let day = moment(this.value).format("YYYY-MM-DD")
      this.confirmValue(day)
    }, 200)
  }
}
</script>

<style scoped>
.border {
  border: rgb(216, 220, 230) 1px solid;
}

.is-selected {
  color: #1989fa;
}

.border :deep(.el-calendar-day) {
  box-sizing: border-box;
  padding: 0;
  height: 100%;
}

.dayDiv {
  font-size: 25px;
}

.dateDiv {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}


.dateDiv_1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #c9f5cb;
}

.div-text {
  width: 45px;
  height: 45px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 25px;
}


.restDiv {
  width: 40px;
  height: 40px;
  text-align: center;
  border-radius: 50%;
  color: #909399;
  background-color: #e5e5e5;
  margin-bottom: 8px;
}

.workDiv {
  width: 40px;
  height: 40px;
  text-align: center;
  border-radius: 50%;
  color: whitesmoke;
  background-color: #0486fe;
  margin-bottom: 8px;
}

.holidayDiv {
  width: 40px;
  height: 40px;
  text-align: center;
  border-radius: 50%;
  color: whitesmoke;
  background-color: #42b983;
  margin-bottom: 8px;
}

.date_button {
  margin-left: 0;
}

.day_shift_type_true {
  padding: 0;
  border-radius: 0;
  width: 16%;
  line-height: 20px;
  height: 20px;
  color: white;
  text-align: center;
  font-size: 16px;
  margin-left: 5px;
  margin-bottom: 3px;
}

.day_shift_type_false {
  padding: 0;
  border-radius: 0;
  width: 16%;
  line-height: 20px;
  height: 20px;
  text-align: center;
  border: #0486fe 1px dashed;
  margin-left: 5px;
  margin-bottom: 3px;
}

.night_shift_type_true {
  padding: 0;
  border-radius: 0;
  width: 16%;
  line-height: 20px;
  height: 20px;
  color: white;
  font-size: 16px;
  margin-left: 5px;
  text-align: center;
  margin-bottom: 3px;
}

.night_shift_type_false {
  padding: 0;
  border-radius: 0;
  width: 16%;
  line-height: 20px;
  height: 20px;
  border: #223342 1px dashed;
  font-size: 16px;
  margin-left: 5px;
  margin-bottom: 3px;
  text-align: center;
}

.day_shift_button_false {
  width: 40px;
  height: 50px;
  border-radius: 0;
  border: 1px #0486fe dashed;
  line-height: 50px;
  margin-right: 12%;
  text-align: center;
}

.day_shift_button_true {
  width: 40px;
  height: 50px;
  border-radius: 0;
  line-height: 50px;
  margin-right: 12%;
  text-align: center;
  color: white;
}

.color1 {
  background-color: #2bd82f;
}

.color2 {
  background-color: burlywood;
}

.color3 {
  background-color: #0486fe;
}

.night_shift_button_false {
  width: 40px;
  height: 50px;
  border-radius: 0;
  line-height: 50px;
  margin-right: 12%;
  text-align: center;
  border: 1px #223342 dashed;
}

.night_shift_button_true {
  width: 40px;
  height: 50px;
  border-radius: 0;
  line-height: 50px;
  margin-right: 12%;
  text-align: center;
  color: white;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  width: 100%;
}

/*.border :deep(.el-calendar__body) {*/
/*  padding: 0;*/
/*}*/


</style>